import React, { useEffect, useRef, useState } from "react"
import Modal from "../../../../components/Modal"
import { TAwpChat, TAwpSendMessage } from "../../../../services/statisticsAPI"
import { WebHookWhatsapp } from "../../../../types/messageDatas"

interface ChatModalProps {
  isOpen: boolean
  onClose: () => void
  chatData: any
}

const ChatModal: React.FC<ChatModalProps> = ({ isOpen, onClose, chatData }) => {
  const [messages, setMessages] = useState<WebHookWhatsapp[]>()
  const [newMsg, setNewMsg] = useState("")
  const scrollRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!isOpen) {
      return
    }

    handleFetchData(1, 100, chatData.from)

    const iv = setInterval(() => {
      handleFetchData(1, 100, chatData.from)
    }, 5000)

    return () => clearInterval(iv)
  }, [isOpen, chatData])

  const handleFetchData = async (page: number, perPage: number, from: string) => {
    try {
      const response = await TAwpChat(page, perPage, from)
      const data = response.chat.reverse()
      setMessages(data)
    } catch (error) {
      console.error("Error fetching chat data:", error)
    }
  }

  const handleSend = async (phoneNumber: string, message: string) => {
    if (!phoneNumber || !message || message.trim() === "") {
      return
    }
    try {
      const newPhoneNumber = chatData.from.replace("whatsapp:", "")
      await TAwpSendMessage(newPhoneNumber, message)
      setNewMsg("")
    } catch (error) {
      console.log("Error sending message:", error)
    }
  }

  return (
    <>
      {isOpen && (
        <div className="flex  w-full items-center justify-center">
          <Modal
            classname="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
            classname2="relative bg-white rounded-3xl w-full max-w-md h-[80vh] flex flex-col overflow-hidden"
            onClick={onClose}
          >
            {/* HEADER */}
            <div
              className="flex-shrink-0 px-6 py-4 border-b bg-white flex items-center justify-between"
              onClick={(e) => e.stopPropagation()}
            >
              <div>
                <h2 className="text-xl font-bold">{chatData.profileName}</h2>
                <p className="text-sm text-gray-500">{chatData.from.replace("whatsapp:", "")}</p>
              </div>
              <button
                onClick={() => {
                  onClose()
                  setMessages([])
                }}
                className="text-white bg-blue-500 hover:bg-blue-600 rounded px-3 py-1"
              >
                X
              </button>
            </div>

            {/* BODY */}
            <div
              ref={scrollRef}
              className="flex-1 overflow-y-auto overscroll-contain px-4 py-3 space-y-3 bg-gray-50"
              onClick={(e) => e.stopPropagation()}
            >
              {messages &&
                messages?.map((m, idx) => {
                  const isMine = m.profileName === "TEAMFLUENCER"
                  return (
                    <div key={idx} className={`flex ${isMine ? "justify-end" : "justify-start"}`}>
                      <div
                        className={`max-w-xs px-4 py-2 rounded-lg ${
                          isMine ? "bg-blue-500 text-white" : "bg-gray-200 text-gray-800"
                        }`}
                      >
                        <p className="whitespace-pre-wrap">{m.body}</p>
                        <time className="block text-xs text-gray-400 text-right mt-1">
                          {new Date(m.createdAt).toLocaleTimeString("tr-TR", {
                            hour: "2-digit",
                            minute: "2-digit",
                          })}
                        </time>
                      </div>
                    </div>
                  )
                })}
            </div>

            {/* FOOTER */}
            <div
              className="flex-shrink-0 px-4 py-3 border-t bg-white flex items-center space-x-2"
              onClick={(e) => e.stopPropagation()}
            >
              <input
                value={newMsg}
                onChange={(e) => setNewMsg(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && handleSend(chatData.from, newMsg)}
                className="flex-1 border rounded px-3 py-2 focus:outline-none focus:ring"
                placeholder="Mesaj yazın…"
              />
              <button
                onClick={() => handleSend(chatData.from, newMsg)}
                className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
              >
                Gönder
              </button>
            </div>
          </Modal>
        </div>
      )}
    </>
  )
}

export default ChatModal
